import { render, staticRenderFns } from "./Movimenti.vue?vue&type=template&id=6ada613e"
import script from "./Movimenti.vue?vue&type=script&lang=js"
export * from "./Movimenti.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports